import axios from "axios";
import config from "../../config/config";
import Cookie from "cookies-js";


export const reportG2 = {
    getReportData,
    getMobileAvgFixed,
    reportMonth,
    reportYear,
    reportBetweenYear,
    reportQuarter,
    reportBetweenQuarter,
    getAllReportData,
    getAvgRegulate,
    getProportionMobileRate,
    getForcastAvg
};

function getReportData(data){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "reportG2/getAvgReport/?authorization=" + json_cookie.token, data)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function getMobileAvgFixed(data){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc)
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "reportG2/getMobileAvgFixed/?authorization="+ json_cookie.token, data)
        .then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}

function reportMonth(data) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "reportG2/reportMonth/?authorization=" + json_cookie.token, data)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function reportYear(data) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "reportG2/reportYear/?authorization=" + json_cookie.token, data)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function reportBetweenYear(data) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "reportG2/reportBetweenYear/?authorization=" + json_cookie.token, data)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function reportQuarter(data) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "reportG2/reportQuarter/?authorization=" + json_cookie.token, data)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function reportBetweenQuarter(data) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "reportG2/reportBetweenQuarter/?authorization=" + json_cookie.token, data)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function getAllReportData(formdata){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "reportG2/getAllReportData/?authorization=" + json_cookie.token, formdata)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function getAvgRegulate(frequency){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.get(config.API_URL + "reportG2/getAvgRegulate/?authorization=" + json_cookie.token+'&frequency='+frequency)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function getProportionMobileRate(){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.get(config.API_URL + "reportG2/getProportionMobileRate/?authorization=" + json_cookie.token)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function getForcastAvg(filter){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "reportG2/getForcastAvg/?authorization=" + json_cookie.token, filter)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}